import { initGA4, trackPageView, trackCustomEvent } from '../utils/analytics';

class AnalyticsWrapper {
  static GA_ENABLED = process.env.REACT_APP_ENABLE_GA === "true";
  static initialized = false;

  static initialize() {
    if (this.GA_ENABLED && !this.initialized) {
      const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID || "G-P82N9ZQPZ4";
      initGA4(measurementId);
      this.initialized = true;
      console.log("[GA] Inicializado con éxito con GA4.");
    } else {
      console.log("[DEBUG] Google Analytics deshabilitado.");
    }
  }

  static trackPageView(path) {
    if (this.GA_ENABLED) {
      trackPageView(path);
    } else {
      console.log(`[DEBUG] PageView no enviado (modo desarrollo): ${path}`);
    }
  }

  // Enviar eventos personalizados
  static trackEvent(category, action, label = "", value = 0) {
    if (this.GA_ENABLED) {
      trackCustomEvent(category, action, label, value);
    } else {
      console.log(`[DEBUG] Evento no enviado (modo desarrollo):`, { category, action, label, value });
    }
  }
}

export default AnalyticsWrapper;